import { connect } from 'react-redux';
import * as DocumentsActions from 'documents-ui/actions/DocumentsActions';
import IndexTableRow from 'SalesContentIndexUI/components/IndexTableRow';
import IndexTableRowCellSlot from 'SalesContentIndexUI/slots/IndexTableRowCellSlot';
import IndexTableRowHoverCellSlot from 'SalesContentIndexUI/slots/IndexTableRowHoverCellSlot';
import { isMultiBrandEnabled } from 'documents-lib/js/utils/isMultiBrandEnabled';
import DocumentNameCell from './DocumentNameCell';
import DocumentProgressNameCell from './DocumentProgressNameCell';
import DocumentAnalyticsCell from './DocumentAnalyticsCell';
import DocumentOwnerCell from './DocumentOwnerCell';
import DocumentUpdatedAtCell from './DocumentUpdatedAtCell';
import DocumentBrandCell from './DocumentBrandCell';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DocumentsTableRow = ({
  selectionData,
  searchResult,
  toggleRowSelection,
  moveDocuments,
  downloadDocument,
  fetchDocumentDescription,
  toggleDocumentDescription,
  description
}) => {
  const isLoading = () => {
    return searchResult.getIn(['metadata', 'progress']) !== undefined;
  };
  const renderNameCell = () => {
    if (isLoading()) {
      return /*#__PURE__*/_jsx(IndexTableRowCellSlot, {
        children: /*#__PURE__*/_jsx(DocumentProgressNameCell, {
          searchResult: searchResult
        })
      });
    }
    return /*#__PURE__*/_jsx(IndexTableRowHoverCellSlot, {
      children: /*#__PURE__*/_jsx(DocumentNameCell, {
        searchResult: searchResult,
        moveDocuments: moveDocuments,
        downloadDocument: downloadDocument,
        fetchDocumentDescription: fetchDocumentDescription,
        toggleDocumentDescription: toggleDocumentDescription,
        description: description
      })
    });
  };

  // `metadata` could be missing if SalesContentSearch or Sequences BE have
  // issues, so we'll handle that below and leave the columns empty.
  const metadata = searchResult.metadata;
  return /*#__PURE__*/_jsxs(IndexTableRow, {
    disabled: isLoading(),
    searchResult: searchResult,
    selectionData: selectionData,
    toggleRowSelection: toggleRowSelection,
    children: [renderNameCell(), /*#__PURE__*/_jsx(IndexTableRowCellSlot, {
      children: metadata && /*#__PURE__*/_jsx(DocumentAnalyticsCell, {
        count: metadata.get('numShares')
      })
    }), /*#__PURE__*/_jsx(IndexTableRowCellSlot, {
      children: metadata && /*#__PURE__*/_jsx(DocumentAnalyticsCell, {
        count: metadata.get('numViews')
      })
    }), /*#__PURE__*/_jsx(IndexTableRowCellSlot, {
      children: /*#__PURE__*/_jsx(DocumentOwnerCell, {
        searchResult: searchResult
      })
    }), isMultiBrandEnabled() && /*#__PURE__*/_jsx(IndexTableRowCellSlot, {
      children: /*#__PURE__*/_jsx(DocumentBrandCell, {
        searchResult: searchResult
      })
    }), /*#__PURE__*/_jsx(IndexTableRowCellSlot, {
      children: /*#__PURE__*/_jsx(DocumentUpdatedAtCell, {
        searchResult: searchResult
      })
    })]
  });
};
export default connect(state => {
  return {
    description: state.documents.description
  };
}, Object.assign({}, DocumentsActions))(DocumentsTableRow);